export default {
  MuiPaper: {
    defaultProps: {
      elevation: 3,
    },
    styleOverrides: {
      root: {
        borderRadius: '18px',
        transition: 'background 0.5s ease-in-out',
      },
    },
  },
  MuiTypography: {
    defaultProps: {
      variant: 'body1',
    },
  },
  MuiButton: {
    defaultProps: {
      variant: 'contained',
    },
    styleOverrides: {
      root: {
        borderRadius: '25px',
      },
    },
  },
  MuiOutlinedInput: {
    defaultProps: {
      style: {
        borderRadius: '12px',
      },
    },
  },
};
